  <nz-breadcrumb>
    <nz-breadcrumb-item *ngFor="let item of breadcrumbList">
      <a *ngIf="!item.is_active" [routerLink]="item.url"><h3>{{item.name}}</h3></a>
      <a *ngIf="item.is_active">{{item.name}}</a>
    </nz-breadcrumb-item>
  </nz-breadcrumb>

  